
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalItemsGrid extends Serenity.EntityGrid<POSApprovalItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalItems'; }
        protected getDialogType() { return POSApprovalItemsDialog; }
        protected getIdProperty() { return POSApprovalItemsRow.idProperty; }
        protected getInsertPermission() { return POSApprovalItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalItemsRow.localTextPrefix; }
        protected getService() { return POSApprovalItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true; 
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }

}